<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard">

            <p-toast key="toastmsg"></p-toast>

            <div class="mainDivHeader">
              <div class="leftdiv">
                <h4>Razor Payment Report<span class="badge">{{totalRecords}}</span></h4>
              </div>

              <div class="rightDiv">
                <button class="exportBTn" (click)="exportExcel()"> <span><img
                      src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
                  Export</button>
              </div>
            </div>  

            <div class="mainDivBody">
                <div class="date-filterDiv">
                    <ul class="filtersList">
                    <li>
                        <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                            optionLabel="label"></p-dropdown>
                    </li>
                    <li>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                        class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="FROM: dd / mm / yy"></p-calendar>
                    </li>
                    <li>
                        <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                        class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" placeholder="TO: dd / mm / yy"></p-calendar>
                    </li>
                    <li>
                        <!-- <button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-" (click)="loadWallet($event)"></button> -->
                        <button (click)="loadWalletHistory(lastTableLazyLoadEvent)" class="searchFilterBtn">
                        <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
                        </button>
                    </li>
                    <li>
                        <!-- <button pButton label="Clear Filters" class="p-button-outlined p-mr-2 p-mb-2" icon="pi pi-filter-slash" (click)="clear()"></button> -->
                        <button (click)="clear()" class="clearFilterBtn">
                        <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                        <span>Clear All</span>
                        </button>
                    </li>
                    </ul>
                </div>

                <div class="maintableDiv">
                    <div class="tableParanet">
                        <p-table class="p2-table-columns show-columns" #dt [value]="walletlist" [paginator]="true" [rows]="10"
                            [lazy]="true" (onLazyLoad)="loadWalletHistory($event)" [totalRecords]="totalRecords" [loading]="loading"
                            [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th pSortableColumn="id" class="transactionTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Transaction ID
                                            <!-- <p-sortIcon field="id"></p-sortIcon> -->
                                        </div>
                                    </th>
                                    <th pSortableColumn="userName" class="usernameTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            User Name
                                            <!-- <p-sortIcon field="userName"></p-sortIcon> -->
                                        </div>
                                    </th>
                                    <th pSortableColumn="userEmail" class="emailTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Email
                                            <!-- <p-sortIcon field="userEmail"></p-sortIcon> -->
                                        </div>
                                    </th>
                                
                                    <th pSortableColumn="userMobile" class="mobileTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Mobile
                                            <!-- <p-sortIcon field="userMobile"></p-sortIcon> -->
                                        </div>
                                    </th>
                                    <th pSortableColumn="paymentId" class="paymentTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Razorpay Payment Id
                                            <!-- <p-sortIcon field="paymentId"></p-sortIcon> -->
                                        </div>
                                    </th>
                                    <th pSortableColumn="description" class="descriptionTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">Description</div>
                                    </th>
                                    <th pSortableColumn="amount" class="ammoutnTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Amount
                                            <p-sortIcon field="amount"></p-sortIcon>
                                        </div>
                                    </th>
                                    <th pSortableColumn="created_at" class="createTD">
                                        <div class="p-d-flex p-jc-between p-ai-center">
                                            Created Date
                                            <p-sortIcon field="created_at"></p-sortIcon>
                                        </div>
                                    </th>
                                </tr>

                                <tr>
                                    <th [ngSwitch]="id" class="transactionTD">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'id', 'contains')"
                                            [value]="dt.filters['id'] ? dt.filters['id'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="userName" class="usernameTD">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userName', 'contains')"
                                            [value]="dt.filters['userName'] ? dt.filters['userName'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="userEmail" class="emailTD">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userEmail', 'contains')"
                                            [value]="dt.filters['userEmail'] ? dt.filters['userEmail'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="userMobile" class="mobileTD">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userMobile', 'contains')"
                                            [value]="dt.filters['userMobile'] ? dt.filters['userMobile'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="paymentId" class="paymentTD">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'paymentId', 'contains')"
                                            [value]="dt.filters['paymentId'] ? dt.filters['paymentId'].value : ''" />
                                    </th>
                                    
                                    <th [ngSwitch]="description" class="descriptionTD">
                                        <!-- <p-dropdown appendTo="body" #pDropDownId [options]="description"
                                        (onChange)="setDownloadFlag(); dt.filter($event.value, 'description', 'equals')" placeholder="Select Description"
                                        [showClear]="true">
                                        <ng-template let-option pTemplate="item">
                                            <span [class]="'customer-badge description-' + option.value">{{option.label}}</span>
                                        </ng-template>
                                        </p-dropdown> -->
                                    </th>
                                    <th [ngSwitch]="amount" class="ammoutnTD">
                                        <input pInputText type="text"
                                            (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'amount', 'contains')"
                                            [value]="dt.filters['amount'] ? dt.filters['amount'].value : ''" />
                                    </th>
                                    <th [ngSwitch]="created_at" class="createTD">
                                        <p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
                                            (onSelect)="setDownloadFlag(); dt.filter($event,'created_at', 'dateIs')" [(ngModel)]="calvalue"
                                            class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-userwallet>
                                <tr class="p-selectable-row">
                                    <td class="transactionTD">
                                        {{userwallet.id}}
                                    </td>
                                    <td class="usernameTD">
                                        {{userwallet.userData[0]?.fullName}}
                                    </td>
                                    <td class="emailTD">
                                        {{userwallet.userEmail}}
                                    </td>
                                    <td class="mobileTD">
                                        {{userwallet.userMobile}}
                                    </td>
                                    <td class="paymentTD">
                                        {{userwallet.paymentId}}
                                    </td>
                                    <td class="descriptionTD">
                                        {{userwallet.description}}
                                    </td>
                                    <!-- <td *ngIf="userwallet.coins!=0">                                    
                                        <div class="debit" *ngIf="userwallet.action=='ADD'">
                                            <i class='pi pi-plus'></i> {{userwallet.coins}} {{userwallet.wallettype | lowercase }}<span></span>
                                        </div>
                                        <div class="credits" *ngIf="userwallet.action=='SUBTRACT'">
                                            <i class='pi pi-minus'></i> {{userwallet.coins}} {{userwallet.wallettype | lowercase}} <span></span>
                                        </div>
                                        
                                    </td>
                                    <td *ngIf="userwallet.cash!=0">
                                        <div class="debit" *ngIf="userwallet.action=='ADD'">
                                            <i class='pi pi-plus'></i> {{userwallet.cash}} {{userwallet.wallettype | lowercase}}<span></span>
                                        </div>
                                        <div class="credits" *ngIf="userwallet.action=='SUBTRACT'">
                                            <i class='pi pi-minus'></i> {{userwallet.cash}} {{userwallet.wallettype | lowercase}} <span></span>
                                        </div>
                                    </td> -->
                                    
                                    <td *ngIf="userwallet.action=='ADD'" class="ammoutnTD">
                                        <!-- <i class='pi pi-plus'></i>  -->
                                        + {{userwallet.amount}} {{userwallet.wallettype | lowercase }}
                                    </td>
                                    <td *ngIf="userwallet.action=='SUBTRACT'" class="minus_td">
                                        <!-- <i class='pi pi-minus'></i>  -->
                                        - {{userwallet.amount}} {{userwallet.wallettype | lowercase }}
                                    </td>
                                    <td class="createTD">
                                        {{userwallet.created_at | date:'d/M/yyyy'}}
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="8">No Payment Details.</td>
                                </tr>
                            </ng-template>
                            <!-- <ng-template pTemplate="summary">
                                <div class="p-d-flex p-ai-center p-jc-between">
                                    In total there are {{totalRecords }} User Payment Details.
                                </div>
                            </ng-template> -->
                        </p-table>
                    </div>
                </div>        
            </div>        
    </div>
</div>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
